<template>
<card class="flex" :toggleable="toggleable !== false">
        <template slot="header">
            <i class="material-icons">search</i>
            <strong class="ml-2">Find a facility</strong>
        </template>

        <template slot="body">
            <div class="flex">
                <div class="flex-50">
                    <form @submit.prevent="onSearchSubmit">
                        <div>
                            <label for="facility-search">Facility Number</label>

                            <div class="flex jc-sb">
                                <input class="flex-a mr-2" id="facility-search" type="text" v-model="facility_query" />

                                <div v-show="is_loading_search" class="flex ai-c">
                                    <img src="../assets/img/loading-black-32.gif" alt="loading" />
                                </div>

                                <button :disabled="facility_query.length < 1 || is_loading_search" class="flex-0 ml-2" type="submit">Search</button>
                            </div>

                            <div class="hint mt-3">Hint: Partial queries are supported.</div>
                        </div>
                    </form>
                </div>

                <div class="flex-0 ml-6 mr-6">
                    <div class="gray-divider"></div>
                </div>

                <div class="flex-50">
                    <label for="facility">Facility</label>
                    <select-input ref="facility_dropdown"
                        :active-index="selected_facility_index"
                        :disabled="facility_options.length < 1"
                        :choices="facility_options"
                        @change="onChangeFacility">
                    </select-input>
                </div>
            </div>
        </template>
    </card>
</template>

<script>
import http from "@/http"

export default {
    name: "find-facility-card",

    props: ["initialQuery", "toggleable"],

    data () {
        return {
            clean: true,
            facilities: [],
            selected_facility_index: null,
            facility_query: "",
            is_loading_search: false
        }
    },

    computed: {
        facility_options: function () {
            return this.facilities.map(facility => {
                let label = `<span>${facility.facility_number}</span>`

                if (facility.account_name) {
                    label += ` - <span>${facility.account_name}</span>`
                } else {
                    label += " - <em class='gray-message'>No account name</em>"
                }

                return { key: facility.id, label, badge: null }
            })
        },

        selected_facility: function () {
            return this.facilities[this.selected_facility_index]
        }
    },

    watch: {
        initialQuery: function (newValue) {
            if (this.clean) {
                this.facility_query = newValue

                this.onSearchSubmit()
            }
        }
    },

    methods: {
        /**
         * Set the chosen facility and alert the parent.
         *
         * @param mixed index Index of the selected facility
         */
        onChangeFacility (index) {
            this.clean = false
            this.selected_facility_index = index

            this.$emit("change", this.selected_facility)
        },

        /**
         * Load all facilities based on a facility number search.
         *
         * @return null
         */
        async onSearchSubmit () {
            const query = encodeURIComponent(`%${this.facility_query}%`)

            this.is_loading_search = true
            this.$emit("loading")

            this.facilities = []

            try {
                const { data: response } = await http(`/api/facilities/search?facility_number=${query}`)

                this.$emit("loaded")

                this.selected_facility_index = null
                this.facilities = response

                if (this.facilities.length === 1) {
                    this.onChangeFacility(0)
                }
            } catch (ex) {
                if (ex.message) {
                    this.$emit("error", ex.message)
                } else {
                    this.$emit("error", ex)
                }
            } finally {
                this.is_loading_search = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FindFacilityCard.vue